import React from "react";
import {toJpeg} from "html-to-image";
import './ImageGenerator.scss';

const classNameUpdater = (childNodes: any, className: string, classNameUpd: string) => {
    const length = childNodes.length;

    for (let i = 0; i < length; ++i) {
        const item: Element | null = childNodes.item(i);

        if (item && className === item.className) {
            item.className = classNameUpd;
        }
    }
};

const interactiveStrokeUpdater = (nodes: any, color: string, colorUpd: string) => {
    const classes = [
        'leaflet-pane leaflet-map-pane',
        'leaflet-pane leaflet-overlay-pane',
        'leaflet-zoom-animated',
    ];

    const nodeNames = [
        'svg',
        'g',
    ];

    const length = nodes.length;

    for (let i = 0; i < length; ++i) {
        const item: Element | null = nodes.item(i);

        if (item && classes.includes(item.className)) {
            interactiveStrokeUpdater(item.childNodes, color, colorUpd);

            continue;
        }

        if (item && nodeNames.includes(item.nodeName)) {
            interactiveStrokeUpdater(item.childNodes, color, colorUpd);

            continue;
        }

        if (item && 'path' === item.nodeName) {
            const attributes: NamedNodeMap = item.attributes;

            if (attributes) {
                const stroke: Attr | null = attributes.getNamedItem('stroke');

                if (stroke && stroke.nodeValue === color) {
                    stroke.nodeValue = colorUpd;
                }
            }
        }
    }
};

const ImageGenerator: React.FC<{ lfRef: any }> = props => {
    const onGenerateHandler = async () => {
        const lfRef = props.lfRef.current;
        if (lfRef) {
            const htmlMap: any = lfRef.firstChild;
            if (!htmlMap) {
                return null;
            }

            const childNodes: any = htmlMap.childNodes;

            await interactiveStrokeUpdater(childNodes, '#B1B1B1', 'ik-stroke-none');
            await classNameUpdater(childNodes, 'leaflet-control-container', 'leaflet-control-container-none');

            const options = {quality: 1, width: 815, height: 610};

            toJpeg(htmlMap, options)
                .then(function (dataUrl: any) {
                    const link = document.createElement('a');

                    link.download = 'ikgenerator-map.jpeg';
                    link.href = dataUrl;

                    link.click();

                    classNameUpdater(childNodes, 'leaflet-control-container-none', 'leaflet-control-container');
                    interactiveStrokeUpdater(childNodes, 'ik-stroke-none', '#B1B1B1');
                });
        }
    };

    return (
        <div className="imageGeneratorBtn">
            <div className="buttonDefaultContainer">
                <button className="buttonDefault transition500" onClick={onGenerateHandler}>
                    Générer le document
                </button>
            </div>
        </div>
    );
};

export default ImageGenerator;
